import React from 'react';
import {
	CompanyType,
	TaxconForm,
	Industry,
	RegContactForm,
} from './steps/index.js';
import axios from '../../shared/axios/axiosProxy.js';
import './regFlow.scss';
import i18n from '../../utils/i18n.js';
import { withTranslation } from 'react-i18next';
import peaking1 from '../../images/peaking.png';
import peaking2 from '../../images/peaking2.png';
import peaking3 from '../../images/peaking3.png';
import peaking4 from '../../images/peaking4.png';
import rocketman from '../../images/Rocketman.png';
import blueaccountant from '../../images/BlueAccountant.png';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import VacationNotice from '../../shared/components/vacationNotice/VacationNotice.jsx';
//REDUX
import ACTIONS, {
	fetchAspPotentialProviders,
	fetchCherryPotentialProviders,
} from '../../redux/action.js';
import { connect } from 'react-redux';
import { checkStateChange } from './data/regFlowText.js';
import { ensureSearchExists } from '../utils/ensureSearchExists';
import { pushFlowContextToDataLayer } from '../utils/dataLayerFlowContext';
import { mergeUtmIntoPayload, prepareAspPayload, resolveUtmParams } from '../utils/utmBootstrap';

const mapStateToProps = (state) => ({
	store: state,
	loading: state.loading,
	company_store: state.company_store,
	match_score_weights: state.match_score_weights,
	potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
	addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
	fetchAspPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchAspPotentialProviders(companyData, msWeights)),
	fetchCherryPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});
class RegFlow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 0,
			reqID: '',
			cherryID: '',
			searchID: '',
			completedSteps: 0,
			kNetPlusSent: false,
			helpForm: false,
			stepData: `1 - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`,
			viewedProviders: [],
			vacatiOn: false,
			bookkeepie_id: Cookies.get('bookkeepie_id') || null,
			utm_source: '',
			utm_medium: '',
			utm_campaign: '',
			utm_content: '',
			utm_term: '',
			gclid: '',
			dclid: '',
		};
	}

	dataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			step: stepData,
			event_category: 'regflow',
		});
	}

	bkIdDataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			bookkeepie_id: stepData,
			event_category: 'regflow',
		});
	}

	dataLayerVersionUpdate() {
		pushFlowContextToDataLayer({
			version: 'A',
			flow: 'regflow',
			company_store: this.props.company_store,
		});
	}

	componentDidMount() {
		let bkID = Cookies.get('bookkeepie_id');
		const { company_store, addCompanyInfo } = this.props;

		if (company_store.searchID && company_store.searchID !== '') {
			this.setState({ searchID: company_store.searchID });
			// Reused search from a different flow (e.g. searchFlowVersionB's "founding"
			// handoff, or the old searchFlow's own idk/kft redirects) — correct its
			// leadtype to this flow's type. Always PATCH regardless of what
			// company_store.leadtype already shows: an earlier step may have already
			// dispatched the right value into redux without it ever reaching the backend
			// (redirects there happen via client-side navigate(), with no autosave tick
			// in between). flowStart is intentionally left untouched: it tracks where the
			// search genuinely originated, not where it was later redirected to.
			addCompanyInfo({ id: 'leadtype', data: 'REG', stateObject: 'company_store' });
			axios
				.patch(
					`/api/search/${company_store.searchID}`,
					{ leadtype: 'REG' },
					{ headers: { 'Content-Type': 'application/json' } }
				)
				.catch((error) => {
					console.error(
						'Error correcting leadtype on reused search:',
						error?.response?.data || error.message
					);
				});
		}

		if (company_store.utm_source || company_store.utm_medium || company_store.utm_campaign) {
			this.setState({
				utm_source: company_store.utm_source || '',
				utm_medium: company_store.utm_medium || '',
				utm_campaign: company_store.utm_campaign || '',
				utm_content: company_store.utm_content || '',
				utm_term: company_store.utm_term || '',
				gclid: company_store.gclid || '',
				dclid: company_store.dclid || '',
			});
		}

		addCompanyInfo({
			id: 'abVersion',
			data: 'A',
			stateObject: 'company_store',
		});

		if (!company_store.searchID || company_store.searchID === '') {
			ensureSearchExists({
				flowType: 'REG',
				abVersion: 'A',
				company_store,
				addCompanyInfo,
				step: this.state.activeStep + 1,
				stepData: this.state.stepData,
			}).then((searchID) => {
				if (searchID) this.setState({ searchID });
			});
		}

		this.dataLayerUpdate(this.state.activeStep, 'sf_step_changed');
		this.dataLayerVersionUpdate();

		let cookie = document.cookie;
		if (!cookie.includes('reqsent')) {
			document.cookie = 'reqsent=false';
		}

		if (!bkID) {
			bkID = uuidv4();
			this.setState({ bookkeepie_id: bkID });
			Cookies.set('bookkeepie_id', bkID, { expires: 90 });
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
			axios
				.post(
					`/api/searchUser`,
					{
						userID: bkID,
						searches: [],
						reqs: [],
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response);
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				});
		} else {
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
		}
		this.bkIdDataLayerUpdate(bkID, 'sf_step_bookkeepie_id');

		const urlParams = new URLSearchParams(window.location.search);
		const urlCompanytype = urlParams.get('companytype');

		if (!company_store.companytype) {
			if (urlCompanytype === 'bt' || urlCompanytype === 'kft') {
				this.props.addCompanyInfo({
					id: 'anwser',
					data: 'founding',
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'newlyfounded',
					data: true,
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'legalentityfounding',
					data: true,
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'companytype',
					data: urlCompanytype,
					stateObject: 'company_store',
				});
			}
		}

		if (company_store.activeStep !== 0) {
			this.setState({ activeStep: 1 });
		}
	}
	componentDidUpdate(_prevProps, prevState) {
		let bkID = Cookies.get('bookkeepie_id');
		if (bkID) {
			let searchList = [];
			axios
				.get(`/api/searchUser/${bkID}`, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then((response) => {
					searchList = response.data.searchUser.searches.filter(
						(value) => value !== null
					);
					const sid = this.state.searchID;
					const sidStr = sid && String(sid).trim();
					if (sidStr && !searchList.some((s) => String(s) === sidStr)) {
						searchList.push(sidStr);
						let uniques = [
							...new Set(
								searchList.filter((item) => String(item).trim() !== '')
							),
						];
						axios.patch(
							`/api/searchUser/${bkID}`,
							{ searches: uniques },
							{
								headers: {
									'Content-Type': 'application/json',
								},
							}
						);
					}
				})
				.catch((error) => {
					console.log('AXIOS ERROR COMPUPDATE: ', error.response);
				});
		}

		this.handleSearchUpdate(prevState.activeStep);
		if (
			this.state.completedSteps >= 14 &&
			checkStateChange(_prevProps.company_store, this.props.company_store) ===
				true
		) {
			this.props.fetchAspPotentialProviders(
				this.props.company_store,
				this.props.match_score_weights
			);
		}
		if (
			this.state.completedSteps >= 15 &&
			this.state.reqID.length > 0 &&
			checkStateChange(_prevProps.company_store, this.props.company_store)
		) {
			this.props.addCompanyInfo({
				id: 'selected_providers',
				data: [],
				stateObject: 'company_store',
			});
		}
	}

	handleNext = (increment = 1) => {
		if (this.state.activeStep <= 15) {
			if (this.state.searchID === '') {
				this.submitSearchData();
			}
			this.setState({
				activeStep: this.state.activeStep + increment,
			});
			this.dataLayerUpdate(
				this.state.activeStep + increment,
				'sf_step_changed'
			);
			if (this.state.completedSteps < this.state.activeStep) {
				this.setState({
					completedSteps: this.state.completedSteps + increment,
				});
			}
			this.props.addCompanyInfo({
				id: 'isCommission',
				data: true,
				stateObject: 'company_store',
			});
		}
		window.scrollTo(0, 0);
	};
	handleBack = (decr = 1) => {
		if (this.state.activeStep !== 0) {
			this.setState({ activeStep: this.state.activeStep - decr });
		}
		window.scrollTo(0, 0);
	};
	handleTracker = (step) => {
		this.setState({ activeStep: step });
	};
	handleKnetPlusContact = () => {
		this.setState({ kNetPlusSent: true });
	};
	openHelpForm = () => {
		this.setState({ helpForm: true });
	};
	closeHelpForm = () => {
		this.setState({ helpForm: false });
	};
	createAspRequest = (companyData) => {
		let data = prepareAspPayload(companyData, {
			searchID:
				this.state.searchID ||
				this.props.company_store?.searchID ||
				companyData.searchID ||
				'',
			abVersion: this.props.company_store.abVersion || 'A',
		});
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		if (data.incominginvoices === '') {
			data.incominginvoices = 0;
		}
		if (data.outgoinginvoices === '') {
			data.outgoinginvoices = 0;
		}

		axios
			.post(`/api/aspreq`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				sessionStorage.setItem('reqEmail', data.email);
				const reqID = response.data.result._id;
				const searchID = response.data.searchID || this.state.searchID;

				console.log('ASP Request created successfully:', {
					reqID: reqID,
					searchID: searchID,
					backendSearchID: response.data.searchID,
					existingSearchID: this.state.searchID,
				});

				// Update state with callback to ensure it's set before next call
				this.setState({ reqID: reqID }, () => {
					this.props.addCompanyInfo({
						id: 'reqID',
						data: reqID,
						stateObject: 'company_store',
					});

					// Update searchID if backend created/returned one
					if (response.data.searchID && !this.state.searchID) {
						this.setState({ searchID: response.data.searchID }, () => {
							this.props.addCompanyInfo({
								id: 'searchID',
								data: response.data.searchID,
								stateObject: 'company_store',
							});
							this.handleSearchRequestSent(reqID);
						});
					} else {
						this.handleSearchRequestSent(reqID);
					}
				});
			})
			.catch((error) => {
				console.error('Failed to create ASP request:', {
					error: error.response?.data || error.message,
					searchID: this.state.searchID,
					email: data.email,
				});
			});
	};

	createCherryRequest = (companyData) => {
		let data = Object.assign({}, companyData);
		let ppArray = [];
		for (var i in data.potential_providers) {
			ppArray.push(data.potential_providers[i]);
		}
		data.potential_providers = ppArray;

		// Use state first, then Redux so we send searchID even if state wasn't synced yet
		data.searchID =
			this.state.searchID ||
			this.props.company_store?.searchID ||
			data.searchID ||
			'';
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		if (data.incominginvoices === '') {
			data.incominginvoices = 0;
		}
		if (data.outgoinginvoices === '') {
			data.outgoinginvoices = 0;
		}

		axios
			.post(`/api/request`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				const reqID = response.data.result._id;
				const cherryID = reqID;
				const searchID = response.data.searchID || this.state.searchID;

				console.log('Cherry Request created successfully:', {
					reqID: reqID,
					cherryID: cherryID,
					searchID: searchID,
					backendSearchID: response.data.searchID,
					existingSearchID: this.state.searchID,
				});

				this.setState({ cherryID: cherryID }, () => {
					this.props.addCompanyInfo({
						id: 'cherryID',
						data: cherryID,
						stateObject: 'company_store',
					});

					if (this.state.reqID === '' || !this.state.reqID) {
						this.setState({ reqID: reqID }, () => {
							this.props.addCompanyInfo({
								id: 'reqID',
								data: reqID,
								stateObject: 'company_store',
							});

							// Update searchID if backend created/returned one
							if (response.data.searchID && !this.state.searchID) {
								this.setState({ searchID: response.data.searchID }, () => {
									this.props.addCompanyInfo({
										id: 'searchID',
										data: response.data.searchID,
										stateObject: 'company_store',
									});
									this.handleSearchRequestSent(reqID);
								});
							} else {
								this.handleSearchRequestSent(reqID);
							}
						});
					} else {
						// Update searchID if backend created/returned one
						if (response.data.searchID && !this.state.searchID) {
							this.setState({ searchID: response.data.searchID }, () => {
								this.props.addCompanyInfo({
									id: 'searchID',
									data: response.data.searchID,
									stateObject: 'company_store',
								});
								this.handleSearchRequestSent(reqID);
							});
						} else {
							this.handleSearchRequestSent(reqID);
						}
					}
				});
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error);
			});
	};
	updateRequest = (companyData, reqID = this.state.reqID) => {
		let data = Object.assign({}, companyData);
		if (data.potential_providers) {
			delete data.potential_providers;
		}
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		let dataToSend = { reqData: data, reqID: reqID };
		axios
			.patch(`/api/request/addprov`, dataToSend, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	updateFakeCherryRequest = (companyData) => {
		let data = Object.assign({}, companyData);
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		let dataToSend = { reqData: data, reqID: this.state.reqID };
		axios
			.patch(`/api/aspreq/addprov/addfakecherry`, dataToSend, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	handleSearchRequestSent = (reqID = null) => {
		const timeStamp = this.state.stepData.concat(
			` Req sent - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`
		);
		const actualReqID = reqID || this.state.reqID;
		this.setState({ stepData: timeStamp }, () =>
			this.updateSearchData(timeStamp, actualReqID)
		);
		// Backend already updates rfpsent and reqID, no need for frontend update
	};

	submitSearchData = () => {
		const cs = this.props.company_store;
		if (!this.state.searchID && cs.searchID) {
			this.setState({ searchID: cs.searchID });
			return;
		}
		if (!this.state.searchID && !cs.searchID) {
			ensureSearchExists({
				flowType: 'REG',
				abVersion: 'A',
				company_store: cs,
				addCompanyInfo: this.props.addCompanyInfo,
				step: this.state.activeStep + 1,
				stepData: this.state.stepData,
			}).then((searchID) => {
				if (searchID) this.setState({ searchID });
			});
			return;
		}

		let data = { ...cs };
		data.step = this.state.activeStep + 1;
		data.time = this.state.stepData;
		data.returnedProviders = 0;
		data.screenWidth = `${window.innerWidth}`;
		data.lang = cs.chosenLanguage;
		data.leadtype = 'REG';
		data.flowStart = cs.flowStart || 'REG';
		mergeUtmIntoPayload(
			data,
			this.state,
			resolveUtmParams({ company_store: cs, componentState: this.state })
		);
		data.abVersion = cs.abVersion || 'A';

		const effectiveSearchID =
			this.state.searchID || this.props.company_store?.searchID;
		if (
			effectiveSearchID &&
			effectiveSearchID !== 'undefined' &&
			effectiveSearchID !== 'null'
		) {
			axios
				.patch(
					`/api/search/${effectiveSearchID}`,
					{
						leadtype: 'REG',
						flowStart: cs.flowStart || 'REG',
						abVersion: cs.abVersion || 'A',
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('Search updated: ', response.statusText);
				})
				.catch((error) => {
					console.log('AXIOS ERROR updating search: ', error.response.data);
				});
		} else {
			axios
				.post(`/api/search`, data, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response.statusText);
					this.setState({ searchID: response.data.result._id });
					response.data.result._id &&
						this.props.addCompanyInfo({
							id: 'searchID',
							data: response.data.result._id,
							stateObject: 'company_store',
						});
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				});
		}
	};
	updateSearchData = (time, reqID = null) => {
		const effectiveSearchID =
			this.state.searchID || this.props.company_store?.searchID;
		if (
			!effectiveSearchID ||
			effectiveSearchID === 'undefined' ||
			effectiveSearchID === 'null'
		) {
			return;
		}

		let data = { ...this.props.company_store };
		const timeValue = time ?? this.state.stepData;
		data.lang = this.props.company_store.chosenLanguage;
		if (!this.state.requestSent) {
			data.step = this.state.activeStep + 1;
		}
		data.time = timeValue;
		// Only include reqID if we have a valid value (backend will set it anyway)
		// Don't send empty string which might overwrite backend value
		const actualReqID = reqID || this.state.reqID;
		if (
			actualReqID &&
			actualReqID !== '' &&
			actualReqID !== null &&
			actualReqID !== undefined
		) {
			data.reqID = actualReqID;
		}
		data.abVersion = this.props.company_store.abVersion || 'A';
		mergeUtmIntoPayload(
			data,
			this.state,
			resolveUtmParams({
				company_store: this.props.company_store,
				componentState: this.state,
			})
		);
		data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
		data.priceWeight = this.props.store.match_score_weights.priceWeight;
		data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
		data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
		data.availabilityWeight =
			this.props.store.match_score_weights.availabilityWeight;
		data.experienceWeight =
			this.props.store.match_score_weights.experienceWeight;
		data.liabilityInsWeight =
			this.props.store.match_score_weights.liabilityInsWeight;
		data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
		if (
			this.props.potential_providers !== undefined &&
			this.props.potential_providers.constructor === Object &&
			this.props.potential_providers.some((e) => e.length !== 0)
		) {
			let rPCounter = 0;
			this.props.potential_providers.forEach((e) => {
				console.log(e, 'EEEEE');
				rPCounter += e.length;
			});

			data.returnedProviders = rPCounter;
			let tempArray = [[], [], []];
			for (let i in this.props.potential_providers) {
				for (let j in i) {
					tempArray[i].push(this.props.potential_providers[i][j].companyname);
				}
			}
			data.providers = tempArray;
		}
		axios
			.patch(`/api/search/${effectiveSearchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	handleSearchUpdate = (prevStep) => {
		if (this.state.activeStep !== prevStep) {
			let timeString = this.state.stepData.concat(
				`, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
					'hu-HU',
					{
						hour12: false,
					}
				)}`
			);
			this.setState({
				stepData: timeString,
			});
			if (this.state.activeStep !== 1) {
				this.updateSearchData(timeString);
			}
		}
		if (prevStep === 'tableUpdate') {
			this.updateSearchData(this.state.stepData);
		}
	};
	updateViewedProviders = (provider) => {
		let data = {};
		let viewedProviders = this.state.viewedProviders;
		if (viewedProviders.length === 0) {
			viewedProviders.push(provider);
		}
		if (
			viewedProviders.length > 0 &&
			!viewedProviders.some((item) => item.name === provider.name)
		) {
			viewedProviders.push(provider);
		}
		data.viewedProviders = viewedProviders;
		this.setState({
			viewedProviders: viewedProviders,
		});
		const effectiveSearchID =
			this.state.searchID || this.props.company_store?.searchID;
		if (
			!effectiveSearchID ||
			effectiveSearchID === 'undefined' ||
			effectiveSearchID === 'null'
		)
			return;
		axios
			.patch(`/api/search/${effectiveSearchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	headerText = {
		0: (
			<div>
				<p className="regFlowHeaderText">{i18n.t('searchflow.headertext5')}</p>
			</div>
		),
		1: (
			<div>
				<p className="regFlowHeaderText">{i18n.t('searchflow.headertext5')}</p>
			</div>
		),
		2: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3b')}</p>
				<p className="regFlowHeaderText">{i18n.t('searchflow.headertext3c')}</p>
			</div>
		),
		3: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.sfresulttext2')}</p>
				<p className="regFlowHeaderText">{i18n.t('searchflow.whatnowtext2')}</p>
			</div>
		),
	};
	imageSource = {
		0: peaking1,
		1: peaking2,
		2: peaking3,
		3: peaking4,
	};

	getStepContent = (step) => {
		switch (step) {
			case 0: {
				return <CompanyType handleNext={this.handleNext} />;
			}
			case 1: {
				return (
					<Industry handleNext={this.handleNext} handleBack={this.handleBack} />
				);
			}
			case 2: {
				return (
					<>
						<TaxconForm
							handleNext={this.handleNext}
							handleBack={this.handleBack}
						/>
					</>
				);
			}
			case 3: {
				return <RegContactForm handleBack={this.handleBack} />;
			}
			default:
				return i18n.t('general.notfound');
		}
	};

	render() {
		return (
			<>
				<VacationNotice />
				<div className={'RFContainer'}>
					{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
						<div className="RFLeftInfoArea">
							<img src={rocketman} alt="RocketMan" className="rocketman" />
						</div>
					)}
					<div
						className={`${
							this.state.activeStep !== 15 && this.state.activeStep !== 16
								? 'RFContentArea'
								: 'RFOfferArea'
						}`}>
						{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
							<div className="RFContentHeader">
								<div>{this.headerText[this.state.activeStep]}</div>

								<div>
									<img
										className="headerImg"
										alt="header"
										src={this.imageSource[this.state.activeStep]}
									/>
								</div>
							</div>
						)}

						{this.getStepContent(this.state.activeStep)}
					</div>
					{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
						<div className="RFRightInfoArea">
							<img
								src={blueaccountant}
								alt="Accountant lady"
								className="blueaccountant"
							/>
						</div>
					)}
				</div>
			</>
		);
	}
}

export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(RegFlow)
);
